import {
    GET_USER_REQUEST,
    GET_USER_SUCCESS,
    GET_USER_FAILURE,
    GET_TRANSACTION_LIST_REQUEST,
    GET_TRANSACTION_LIST_SUCCESS,
    GET_TRANSACTION_LIST_FAILURE,
} from '../constant/actionTypes'

const initState = {
    user: {},
    transactions: [],
    isNoUser: false,
    isloading: false,
}

const wall = (state = initState, action) => {
    switch (action.type) {
        case GET_USER_REQUEST:
            return {
                ...state,
                isloading: true,
            }
        case GET_TRANSACTION_LIST_REQUEST:
            return {
                ...state,
            }
        case GET_USER_SUCCESS:
            return {
                ...state,
                user: action.payload,
                isloading: false,
            }
        case GET_TRANSACTION_LIST_SUCCESS:
            return {
                ...state,
                transactions: action.payload,
            }
        case GET_USER_FAILURE:
            return {
                ...state,
                isNoUser: true,
                isloading: false,
            }
        case GET_TRANSACTION_LIST_FAILURE:
            return {
                ...state,
            }
        default:
            return {
                ...state,
            }
    }
}

export default wall